import type { Client } from '@tsTypes/Client';

export const triggerDeclarationEvent = (userData: Client) => {
  const declarationEvent = new CustomEvent('triggerDeclarationEvent', {
    detail: userData,
  });
  document.dispatchEvent(declarationEvent);
};
